"use strict";

exports.__esModule = true;
exports["default"] = exports.getOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _observer = require("./observer");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var observerOptions = ['root', 'rootMargin', 'threshold'];
var observableProps = ['root', 'rootMargin', 'threshold', 'disabled'];

var getOptions = function getOptions(props) {
  return observerOptions.reduce(function (options, key) {
    var _Object$assign;

    var isRootString = key === 'root' && _utils.toString.call(props.root) === '[object String]';
    return Object.assign(options, (_Object$assign = {}, _Object$assign[key] = isRootString ? document.querySelector(props[key]) : props[key], _Object$assign));
  }, {});
};

exports.getOptions = getOptions;

var ReactIntersectionObserver = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactIntersectionObserver, _React$Component);

  function ReactIntersectionObserver() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(event, _this.externalUnobserve);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNode", function (target) {
      var children = _this.props.children;
      /**
       * Forward hijacked ref to user.
       */

      if ((0, _utils.isChildrenWithRef)(children)) {
        var childenRef = children.ref;

        if (typeof childenRef === 'function') {
          childenRef(target);
        } else if (childenRef && _utils.hasOwnProperty.call(childenRef, 'current')) {
          /*
           * The children ref.current is read-only, we aren't allowed to do this, so
           * in future release it has to go away, and the ref shall be
           * forwarded and assigned to a DOM node by the user.
           */
          childenRef.current = target;
        }
      }

      _this.targetNode = undefined;

      if (target) {
        var targetNode = (0, _reactDom.findDOMNode)(target);

        if (targetNode && targetNode.nodeType === 1) {
          _this.targetNode = targetNode;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "observe", function () {
      if (_this.props.children == null || _this.props.disabled) {
        return false;
      }

      if (!_this.targetNode) {
        throw new Error("ReactIntersectionObserver: Can't find DOM node in the provided children. Make sure to render at least one DOM node in the tree.");
      }

      _this.observer = (0, _observer.createObserver)(getOptions(_this.props));
      _this.target = _this.targetNode;
      (0, _observer.observeElement)(_assertThisInitialized(_this));
      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "unobserve", function (target) {
      (0, _observer.unobserveElement)(_assertThisInitialized(_this), target);
    });

    _defineProperty(_assertThisInitialized(_this), "externalUnobserve", function () {
      if (_this.targetNode) {
        _this.unobserve(_this.targetNode);
      }
    });

    return _this;
  }

  var _proto = ReactIntersectionObserver.prototype;

  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
    var _this2 = this;

    this.prevTargetNode = this.targetNode;
    var relatedPropsChanged = observableProps.some(function (prop) {
      return (0, _utils.shallowCompare)(_this2.props[prop], prevProps[prop]);
    });

    if (relatedPropsChanged) {
      if (this.prevTargetNode) {
        if (!prevProps.disabled) {
          this.unobserve(this.prevTargetNode);
        }
      }
    }

    return relatedPropsChanged;
  };

  _proto.componentDidUpdate = function componentDidUpdate(_, __, relatedPropsChanged) {
    var targetNodeChanged = false; // check if we didn't unobserve previously due to a prop change

    if (!relatedPropsChanged) {
      targetNodeChanged = this.prevTargetNode !== this.targetNode; // check we have a previous node we want to unobserve

      if (targetNodeChanged && this.prevTargetNode != null) {
        this.unobserve(this.prevTargetNode);
      }
    }

    if (relatedPropsChanged || targetNodeChanged) {
      this.observe();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.observe();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.targetNode) {
      this.unobserve(this.targetNode);
    }
  };

  _proto.render = function render() {
    var children = this.props.children;
    return children != null ? _react["default"].cloneElement(_react["default"].Children.only(children), {
      ref: this.handleNode
    }) : null;
  };

  return ReactIntersectionObserver;
}(_react["default"].Component);

exports["default"] = ReactIntersectionObserver;

_defineProperty(ReactIntersectionObserver, "displayName", 'IntersectionObserver');